import React from 'react';
import { Link } from 'react-router-dom';
import { SITE } from '../../mock';
import { Check, Sparkles, Gift } from 'lucide-react';

export default function BookSection() {
  const features = [
    'A 100+ page manifestation manual — not motivation, a method.',
    'Pairs each chapter with a real assignment you actually complete.',
    'Reprograms the money mind, energy and identity — chapter by chapter.',
    '7-day refund promise. Read anywhere. Apply tonight.',
  ];

  return (
    <section id="book" className="relative py-24 md:py-32 border-t border-white/5 overflow-hidden">
      <div className="pointer-events-none absolute -top-32 right-0 w-[600px] h-[600px] rounded-full bg-amber-300/[0.06] blur-3xl" />
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 md:gap-16 items-center">
        <div className="relative">
          <div className="absolute -inset-6 bg-gradient-to-br from-amber-300/15 via-transparent to-transparent blur-2xl" />
          <div className="relative rounded-3xl overflow-hidden border border-white/10 shadow-[0_30px_80px_-20px_rgba(251,191,36,0.25)]">
            <img
              src={SITE.bookCover}
              alt="You Are The Magician book cover"
              className="w-full h-auto object-cover"
              loading="lazy"
            />
          </div>
        </div>

        <div>
          <p className="text-[11px] tracking-[0.25em] uppercase text-amber-300/80 mb-5 flex items-center gap-2">
            <Sparkles size={14} /> The Companion Manual
          </p>
          <h2 className="font-serif text-white text-[36px] md:text-[54px] leading-[1.05] tracking-tight">
            You Are
            <br />
            <span className="italic text-amber-200">The Magician.</span>
          </h2>
          <p className="mt-6 text-neutral-400 text-[15px] md:text-[17px] leading-relaxed">
            The book that finally explains why hard work isn't making you rich — and the exact
            subconscious blueprint to break your income ceiling for good.
          </p>

          <ul className="mt-8 space-y-3">
            {features.map((f) => (
              <li key={f} className="flex items-start gap-3 text-neutral-200 text-[14px] md:text-[15px]">
                <span className="mt-0.5 w-5 h-5 rounded-full bg-amber-300/15 border border-amber-300/30 flex items-center justify-center text-amber-300">
                  <Check size={12} strokeWidth={2.5} />
                </span>
                {f}
              </li>
            ))}
          </ul>

          <div className="mt-9 flex flex-wrap items-center gap-4">
            <Link
              to="/book"
              className="inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-[15px] font-medium text-navy-900 bg-gradient-to-b from-amber-200 to-amber-400 shadow-[0_8px_30px_-6px_rgba(251,191,36,0.5)] hover:-translate-y-[2px] hover:shadow-[0_14px_40px_-6px_rgba(251,191,36,0.7)] transition-all"
            >
              Get the Book
            </Link>
            <span className="inline-flex items-center gap-2 text-neutral-300 text-sm">
              <Gift size={16} className="text-amber-300" /> 6 free bonuses · worth ₹12,000
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
